var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSurvey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 59,
    height: 48,
    rx: 8,
    fill: "#e5e3f8",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 42.727C6.5 42.4107 6.54617 42.0961 6.63706 41.7931L14.1655 16.6984C15.4027 12.5743 19.1986 9.75 23.5043 9.75H54.4957C58.8014 9.75 62.5973 12.5743 63.8345 16.6984L71.3629 41.7931C71.4538 42.0961 71.5 42.4107 71.5 42.727V58.5C71.5 63.8848 67.1348 68.25 61.75 68.25H16.25C10.8652 68.25 6.5 63.8848 6.5 58.5V42.727ZM54.4957 13H23.5043C20.6338 13 18.1032 14.8828 17.2784 17.6322L9.8931 42.25H27.2414C28.4724 42.25 29.5978 42.9455 30.1483 44.0466L32.491 48.732C32.4965 48.743 32.5078 48.75 32.5201 48.75H45.4799C45.4922 48.75 45.5035 48.743 45.509 48.732L47.8517 44.0466C48.4022 42.9455 49.5276 42.25 50.7586 42.25H68.1069L60.7216 17.6322C59.8968 14.8828 57.3661 13 54.4957 13ZM68.25 45.5H50.7586L48.4159 50.1855C47.8598 51.2975 46.7233 52 45.4799 52H32.5201C31.2768 52 30.1402 51.2976 29.5841 50.1855L27.2414 45.5H9.75V58.5C9.75 62.0898 12.6601 65 16.25 65H61.75C65.3398 65 68.25 62.0898 68.25 58.5V45.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSurvey);
export default __webpack_public_path__ + "static/media/new-survey.f0a478b1a10909bd588945a06c014778.svg";
export { ForwardRef as ReactComponent };